// src/store/useAdminStore.js
import { create } from 'zustand';
import { projects as mockProjects } from "../../data/projectsData";
import { blogPosts as mockPosts } from "../../data/blogData"; 

const useAdminStore = create((set) => ({
  projects: mockProjects,
  blogPosts: mockPosts,
  services: [
    { id: 1, name: "Landing Pro", price: "USD 890", desc: "..." },
    { id: 2, name: "WebApp Full Stack", price: "USD 2.900", desc: "...", popular: true },
    { id: 3, name: "MVP para Startups", price: "Desde USD 4.200", desc: "..." }
  ],

  // Proyectos
  addProject: (project) => set((state) => ({ projects: [...state.projects, { ...project, id: Date.now() }] })),
  updateProject: (id, updated) => set((state) => ({
    projects: state.projects.map(p => p.id === id ? { ...p, ...updated } : p)
  })),
  deleteProject: (id) => set((state) => ({ projects: state.projects.filter(p => p.id !== id) })),

  // Blog
  addPost: (post) => set((state) => ({ blogPosts: [...state.blogPosts, { ...post, id: Date.now() }] })),
  updatePost: (id, updated) => set((state) => ({
    blogPosts: state.blogPosts.map(p => p.id === id ? { ...p, ...updated } : p)
  })),
  deletePost: (id) => set((state) => ({ blogPosts: state.blogPosts.filter(p => p.id !== id) })),

  // Servicios (más adelante)
}));

export default useAdminStore;